import { render, staticRenderFns } from "./list.vue?vue&type=template&id=6f6b4e7c&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=6f6b4e7c&scoped=true&lang=scss&"
import style1 from "./list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b4e7c",
  null
  
)

component.options.__file = "list.vue"
export default component.exports